module.exports = __webpack_public_path__ + "img/artboard4.99351c99.png";